const route = [
    [34.71526604568, 135.36187166225],
    [34.71528293332, 135.36183345159],
    [34.71530111174, 135.3617900066],
    [34.71535338821, 135.36166281208],
    [34.71540394351, 135.36154216062],
    [34.71543094208, 135.36147869441],
    [34.71543847158, 135.36146181368],
    [34.71544363467, 135.36144846612],
    [34.71544578596, 135.36144179234],
    [34.71544729186, 135.36143289397],
    [34.71544772212, 135.36142595847],
    [34.71544729186, 135.36141745267],
    [34.71544664648, 135.36140986288],
    [34.71544471032, 135.36140305825],
    [34.71544255903, 135.36139769305],
    [34.71543997749, 135.36139232786],
    [34.71543567491, 135.36138617751],
    [34.71542857566, 135.36137819515],
    [34.71542438065, 135.3613736151],
    [34.71541964781, 135.36136903506],
    [34.71541125779, 135.36136301557],
    [34.71539071298, 135.361348752],
    [34.71537027573, 135.36133527358],
    [34.71534596615, 135.36132087916],
    [34.71533209033, 135.36131302765],
    [34.71532101113, 135.36130910196],
    [34.71530928659, 135.36130661565],
    [34.71529702428, 135.36130622301],
    [34.71528659052, 135.36130622301],
    [34.71527594162, 135.36130740074],
    [34.71526636837, 135.3613091019],
    [34.71525674129, 135.36131217714],
    [34.71524732938, 135.36131499059],
    [34.71523737965, 135.36131832748],
    [34.71522753748, 135.36132244952],
    [34.71521731884, 135.36132742214],
    [34.71520833719, 135.36133167504],
    [34.71519580595, 135.36133854504],
    [34.71518451166, 135.36134548054],
    [34.71517655187, 135.36135359376],
    [34.71517020555, 135.36136301557],
    [34.71516536513, 135.36137230652],
    [34.71516192301, 135.36138329869],
    [34.71516004063, 135.36139546852],
    [34.7151585885, 135.36140691863],
    [34.71515622208, 135.36141993905],
    [34.71515245731, 135.36143119287],
    [34.71514750933, 135.3614402221],
    [34.71514256135, 135.36144683045],
    [34.71514019493, 135.36145003648],
    [34.71513772094, 135.36145219565],
    [34.71513556964, 135.36145396224],
    [34.71513312251, 135.361455598],
    [34.71512968044, 135.36145854231],
    [34.71512615769, 135.3614614212],
    [34.71512177443, 135.36146495438],
    [34.71511830549, 135.36146672093],
    [34.7151140029, 135.36146901096],
    [34.71510986165, 135.36147188984],
    [34.71510588175, 135.36147457244],
    [34.71510071864, 135.36147790933],
    [34.71509652361, 135.36148131165],
    [34.71509232858, 135.36148451768],
    [34.71508781086, 135.36148844343],
    [34.71508350827, 135.36149335062],
    [34.71507952837, 135.36149760352],
    [34.7150745266, 135.361502707],
    [34.71507129965, 135.36150866106],
    [34.71506807271, 135.3615159237],
    [34.71506570628, 135.36152194319],
    [34.71506317851, 135.36152972926],
    [34.7150613499, 135.36153784249],
    [34.71505973643, 135.36154634828],
    [34.71505844565, 135.36155531208],
    [34.71505855327, 135.3615693793],
    [34.7150584457, 135.36158586746],
    [34.7150587684, 135.36160026189],
    [34.71505995161, 135.36161949807],
    [34.71506005918, 135.36164056628],
    [34.71505866083, 135.36166019504],
    [34.71505349772, 135.36167655235],
    [34.71504639844, 135.36169029248],
    [34.71503843863, 135.36170193888],
    [34.71502843509, 135.36171240755],
    [34.71501843156, 135.36172156764],
    [34.71500659941, 135.36173190546],
    [34.714996811, 135.36174629989],
    [34.71498992684, 135.36176095603],
    [34.71498788311, 135.3617752196],
    [34.71498799067, 135.36178673514],
    [34.71498949658, 135.36179654952],
    [34.7149925084, 135.36180518617],
    [34.71499745639, 135.36181395369],
    [34.71500380272, 135.36182167434],
    [34.71501047175, 135.36182913327],
    [34.71501778617, 135.36183462932],
    [34.71502757458, 135.36184195739],
    [34.71506662074, 135.36186799809],
    [34.71511825187, 135.36190045098],
    [34.71516665602, 135.36193002498],
    [34.71518015523, 135.36193911983],
    [34.71519069658, 135.36194481218],
    [34.71519833367, 135.36194769106],
    [34.71520634724, 135.36194860707],
    [34.71521543646, 135.36194795278],
    [34.71522318111, 135.36194559733],
    [34.71523044173, 135.36194042842],
    [34.71523641157, 135.36193362378],
    [34.71524211249, 135.36192400569],
    [34.71524679156, 135.36191536903],
    [34.71525534295, 135.36189835744],
];

const station = [
    [34.2699650532, 132.91413155846],
    [34.27526320212, 132.92006981161],
    [34.27978789593, 132.92390092412],
];

const station_point = [0, 225, 361];

const station_name = [
    "白水港",
    "古江老人集会所",
    "垂水港",
];

const stop_pos = [34.27136480367, 132.91617418163];

export {
    route,
    station,
    station_point,
    station_name,
    stop_pos
}